var map = {
	"./square/ac.svg": 1741,
	"./square/ad.svg": 1742,
	"./square/ae.svg": 1743,
	"./square/af.svg": 1744,
	"./square/ag.svg": 1745,
	"./square/ai.svg": 1746,
	"./square/al.svg": 1747,
	"./square/am.svg": 1748,
	"./square/ao.svg": 1749,
	"./square/aq.svg": 1750,
	"./square/ar.svg": 1751,
	"./square/as.svg": 1752,
	"./square/at.svg": 1753,
	"./square/au.svg": 1754,
	"./square/aw.svg": 1755,
	"./square/ax.svg": 1756,
	"./square/az.svg": 1757,
	"./square/ba.svg": 1758,
	"./square/bb.svg": 1759,
	"./square/bd.svg": 1760,
	"./square/be.svg": 1761,
	"./square/bf.svg": 1762,
	"./square/bg.svg": 1763,
	"./square/bh.svg": 1764,
	"./square/bi.svg": 1765,
	"./square/bj.svg": 1766,
	"./square/bl.svg": 1767,
	"./square/bm.svg": 1768,
	"./square/bn.svg": 1769,
	"./square/bo.svg": 1770,
	"./square/bq.svg": 1771,
	"./square/br.svg": 1772,
	"./square/bs.svg": 1773,
	"./square/bt.svg": 1774,
	"./square/bv.svg": 1775,
	"./square/bw.svg": 1776,
	"./square/by.svg": 1777,
	"./square/bz.svg": 1778,
	"./square/ca.svg": 1779,
	"./square/cc.svg": 1780,
	"./square/cd.svg": 1781,
	"./square/cefta.svg": 1782,
	"./square/cf.svg": 1783,
	"./square/cg.svg": 1784,
	"./square/ch.svg": 1785,
	"./square/ci.svg": 1786,
	"./square/ck.svg": 1787,
	"./square/cl.svg": 1788,
	"./square/cm.svg": 1789,
	"./square/cn.svg": 1790,
	"./square/co.svg": 1791,
	"./square/cp.svg": 1792,
	"./square/cr.svg": 1793,
	"./square/cu.svg": 1794,
	"./square/cv.svg": 1795,
	"./square/cw.svg": 1796,
	"./square/cx.svg": 1797,
	"./square/cy.svg": 1798,
	"./square/cz.svg": 1799,
	"./square/de.svg": 1800,
	"./square/dg.svg": 1801,
	"./square/dj.svg": 1802,
	"./square/dk.svg": 1803,
	"./square/dm.svg": 1804,
	"./square/do.svg": 1805,
	"./square/dz.svg": 1806,
	"./square/ea.svg": 1807,
	"./square/ec.svg": 1808,
	"./square/ee.svg": 1809,
	"./square/eg.svg": 1810,
	"./square/eh.svg": 1811,
	"./square/er.svg": 1812,
	"./square/es-ct.svg": 1813,
	"./square/es-ga.svg": 1814,
	"./square/es.svg": 1815,
	"./square/et.svg": 1816,
	"./square/eu.svg": 1817,
	"./square/fi.svg": 1818,
	"./square/fj.svg": 1819,
	"./square/fk.svg": 1820,
	"./square/fm.svg": 1821,
	"./square/fo.svg": 1822,
	"./square/fr.svg": 1823,
	"./square/ga.svg": 1824,
	"./square/gb-eng.svg": 1825,
	"./square/gb-nir.svg": 1826,
	"./square/gb-sct.svg": 1827,
	"./square/gb-wls.svg": 1828,
	"./square/gb.svg": 1829,
	"./square/gd.svg": 1830,
	"./square/ge.svg": 1831,
	"./square/gf.svg": 1832,
	"./square/gg.svg": 1833,
	"./square/gh.svg": 1834,
	"./square/gi.svg": 1835,
	"./square/gl.svg": 1836,
	"./square/gm.svg": 1837,
	"./square/gn.svg": 1838,
	"./square/gp.svg": 1839,
	"./square/gq.svg": 1840,
	"./square/gr.svg": 1841,
	"./square/gs.svg": 1842,
	"./square/gt.svg": 1843,
	"./square/gu.svg": 1844,
	"./square/gw.svg": 1845,
	"./square/gy.svg": 1846,
	"./square/hk.svg": 1847,
	"./square/hm.svg": 1848,
	"./square/hn.svg": 1849,
	"./square/hr.svg": 1850,
	"./square/ht.svg": 1851,
	"./square/hu.svg": 1852,
	"./square/ic.svg": 1853,
	"./square/id.svg": 1854,
	"./square/ie.svg": 1855,
	"./square/il.svg": 1856,
	"./square/im.svg": 1857,
	"./square/in.svg": 1858,
	"./square/io.svg": 1859,
	"./square/iq.svg": 1860,
	"./square/ir.svg": 1861,
	"./square/is.svg": 1862,
	"./square/it.svg": 1863,
	"./square/je.svg": 1864,
	"./square/jm.svg": 1865,
	"./square/jo.svg": 1866,
	"./square/jp.svg": 1867,
	"./square/ke.svg": 1868,
	"./square/kg.svg": 1869,
	"./square/kh.svg": 1870,
	"./square/ki.svg": 1871,
	"./square/km.svg": 1872,
	"./square/kn.svg": 1873,
	"./square/kp.svg": 1874,
	"./square/kr.svg": 1875,
	"./square/kw.svg": 1876,
	"./square/ky.svg": 1877,
	"./square/kz.svg": 1878,
	"./square/la.svg": 1879,
	"./square/lb.svg": 1880,
	"./square/lc.svg": 1881,
	"./square/li.svg": 1882,
	"./square/lk.svg": 1883,
	"./square/lr.svg": 1884,
	"./square/ls.svg": 1885,
	"./square/lt.svg": 1886,
	"./square/lu.svg": 1887,
	"./square/lv.svg": 1888,
	"./square/ly.svg": 1889,
	"./square/ma.svg": 1890,
	"./square/mc.svg": 1891,
	"./square/md.svg": 1892,
	"./square/me.svg": 1893,
	"./square/mf.svg": 1894,
	"./square/mg.svg": 1895,
	"./square/mh.svg": 1896,
	"./square/mk.svg": 1897,
	"./square/ml.svg": 1898,
	"./square/mm.svg": 1899,
	"./square/mn.svg": 1900,
	"./square/mo.svg": 1901,
	"./square/mp.svg": 1902,
	"./square/mq.svg": 1903,
	"./square/mr.svg": 1904,
	"./square/ms.svg": 1905,
	"./square/mt.svg": 1906,
	"./square/mu.svg": 1907,
	"./square/mv.svg": 1908,
	"./square/mw.svg": 1909,
	"./square/mx.svg": 1910,
	"./square/my.svg": 1911,
	"./square/mz.svg": 1912,
	"./square/na.svg": 1913,
	"./square/nc.svg": 1914,
	"./square/ne.svg": 1915,
	"./square/nf.svg": 1916,
	"./square/ng.svg": 1917,
	"./square/ni.svg": 1918,
	"./square/nl.svg": 1919,
	"./square/no.svg": 1920,
	"./square/np.svg": 1921,
	"./square/nr.svg": 1922,
	"./square/nu.svg": 1923,
	"./square/nz.svg": 1924,
	"./square/om.svg": 1925,
	"./square/pa.svg": 1926,
	"./square/pe.svg": 1927,
	"./square/pf.svg": 1928,
	"./square/pg.svg": 1929,
	"./square/ph.svg": 1930,
	"./square/pk.svg": 1931,
	"./square/pl.svg": 1932,
	"./square/pm.svg": 1933,
	"./square/pn.svg": 1934,
	"./square/pr.svg": 1935,
	"./square/ps.svg": 1936,
	"./square/pt.svg": 1937,
	"./square/pw.svg": 1938,
	"./square/py.svg": 1939,
	"./square/qa.svg": 1940,
	"./square/re.svg": 1941,
	"./square/ro.svg": 1942,
	"./square/rs.svg": 1943,
	"./square/ru.svg": 1944,
	"./square/rw.svg": 1945,
	"./square/sa.svg": 1946,
	"./square/sb.svg": 1947,
	"./square/sc.svg": 1948,
	"./square/sd.svg": 1949,
	"./square/se.svg": 1950,
	"./square/sg.svg": 1951,
	"./square/sh.svg": 1952,
	"./square/si.svg": 1953,
	"./square/sj.svg": 1954,
	"./square/sk.svg": 1955,
	"./square/sl.svg": 1956,
	"./square/sm.svg": 1957,
	"./square/sn.svg": 1958,
	"./square/so.svg": 1959,
	"./square/sr.svg": 1960,
	"./square/ss.svg": 1961,
	"./square/st.svg": 1962,
	"./square/sv.svg": 1963,
	"./square/sx.svg": 1964,
	"./square/sy.svg": 1965,
	"./square/sz.svg": 1966,
	"./square/ta.svg": 1967,
	"./square/tc.svg": 1968,
	"./square/td.svg": 1969,
	"./square/tf.svg": 1970,
	"./square/tg.svg": 1971,
	"./square/th.svg": 1972,
	"./square/tj.svg": 1973,
	"./square/tk.svg": 1974,
	"./square/tl.svg": 1975,
	"./square/tm.svg": 1976,
	"./square/tn.svg": 1977,
	"./square/to.svg": 1978,
	"./square/tr.svg": 1979,
	"./square/tt.svg": 1980,
	"./square/tv.svg": 1981,
	"./square/tw.svg": 1982,
	"./square/tz.svg": 1983,
	"./square/ua.svg": 1984,
	"./square/ug.svg": 1985,
	"./square/um.svg": 1986,
	"./square/un.svg": 1987,
	"./square/us.svg": 1988,
	"./square/uy.svg": 1989,
	"./square/uz.svg": 1990,
	"./square/va.svg": 1991,
	"./square/vc.svg": 1992,
	"./square/ve.svg": 1993,
	"./square/vg.svg": 1994,
	"./square/vi.svg": 1995,
	"./square/vn.svg": 1996,
	"./square/vu.svg": 1997,
	"./square/wf.svg": 1998,
	"./square/ws.svg": 1999,
	"./square/xk.svg": 2000,
	"./square/xx.svg": 2001,
	"./square/ye.svg": 2002,
	"./square/yt.svg": 2003,
	"./square/za.svg": 2004,
	"./square/zm.svg": 2005,
	"./square/zw.svg": 2006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1740;